import {API_URL, CMS_URL, numberWithCommas, THEME_COLOR} from "../constant"
import React, { useEffect, useState } from 'react';
import InfiniteScroll from "react-infinite-scroller";
import HeaderBack from "../layout/HeaderBack";
import { useLocalStorage } from "../useLocalStorage";
import M from "materialize-css";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import StepLabel from '@mui/material/StepLabel';
import Select from 'react-select';
import { Link } from "react-router-dom";
import banner1 from "../logo.svg"

import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import Stack from '@mui/material/Stack';

import toast, { Toaster } from 'react-hot-toast';

import Warehouse from "./component/Warehouse";
import Expedition from "./component/Expedition";
import FAO from "./component/FAO";
import Bank from "./component/Bank";
import SlidingPane from 'react-sliding-pane';
import "react-sliding-pane/dist/react-sliding-pane.css";
import ItemInfo from "./component/ItemInfo";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import MiniCart from "./component/MiniCart";

const ShopNow = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [wh, setWh] = useLocalStorage("wh", "");
    const [lastViewedItem, setLastViewedItem] = useLocalStorage("lastViewedItem", "");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [cities, setCities] = useState([]);
    const [banks, setBanks] = useState([]);
    const [sponsors, setSponsors] = useState([]);
    const [activeStep, setActiveStep] = React.useState(0);
    const [completed, setCompleted] = React.useState({});
    const [formData, setFormData] = useState({
        "FirstName" : "",
        "LastName" : "",
        "Gender" : "",
        "IDNumber" : "",
        "BirthDate" : "",
        "Email" : "",
        "WhatsappNumber" : "",
        "MobileNumber" : "",
        "Address" : "",
        "City" : "",
        "PostalCode" : "",
        "Bank" : "",
        "AccountNumber" : "",
        "AccountName" : "",
        "Referal" : "",
        "ReferalID": "",
        "ReferalCode": "",
        "ReferalName": "",
    });

    const [itemPage, setItemPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [items, setItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);
    const [cart, setCart] = useState([]);
    
    const [isOpenQty, setIsOpenQty] = useState(false);
    const [isOpenWarehouse, setIsOpenWarehouse] = useState(false);
    const [warehouse, setWarehouse] = useState({})
    const [warehouseDetail, setWarehouseDetail] = useState({})
    const [warehouses, setWarehouses] = useState({})
    const [selectedItem, setSelectedItem] = useState(0);
    const [selectedItemUnitID, setSelectedItemUnitID] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [itemID, setItemID] = useState(0);
    const [itemUnitID, setItemUnitID] = useState(0);
    const [itemName, setItemName] = useState("");
    const [itemCode, setItemCode] = useState("");
    const [itemPrice, setItemPrice] = useState("");
    const [itemSize, setItemSize] = useState("");
    const [itemColor, setItemColor] = useState("");
    const [itemWeight, setItemWeight] = useState(0);
    const [itemImage, setItemImage] = useState("");
    const [address, setAddress] = useState({});
    const [sumOrder, setSumOrder] = useState(0);
    const [sumTotal, setSumTotal] = useState(0);
    const [sumShipping, setSumShipping] = useState(0);
    const [minimumOrder, setMinimumOrder] = useState(0);
    
    const steps = [
        'Shop',
        'Personal Information',
        'Payment',
    ];


    const [isOpen, setIsOpen] = useState(false);
    const [isOpenBank, setIsOpenBank] = useState(false);
    const [isOpenReward, setIsOpenReward] = useState(false);
    const [isOpenFAO, setIsOpenFAO] = useState(false);
    const [isOpenCart, setIsOpenCart] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [selectedWHCityID, setSelectedWHCityID] = useState(-1);
    const [selectedShippingCityID, setSelectedShippingCityID] = useState(-1);
    const [paymentMethod, setPaymentMethod] = useState({
        Code: "",
        Name: ""
    });
    const [rewards, setRewards] = useState([]);
    const [rewardAmount, setRewardAmount] = useState(0);
    const [fao, setfao] = useState({});
    const [totalWeight, setTotalWeight] = useState(0);

    const [qty, setQty] = useState(0);
    const [shippingMethod, setShippingMethod] = useState('SHIP BY');
    const [availStockConfig, setAvailStockConfig] = useState({});

    let prevwh = 0;
    let prevshipmethod = "";
    let prevshipdetail = 0;

    let Cardcontainer = (props) => {

        function ClickExpedition(index,WHCityID, ShippingCityID){
            // console.log(props);
            if(props.onClick){
                props.onClick(index,WHCityID, ShippingCityID)
            }
        }

        let ExpeditionName = () => <span style={{color:"red"}}>Select Expedition</span>;

        useEffect(()=>{
            var elems = document.querySelectorAll('.collapsible');
            var instances = M.Collapsible.init(elems);
        },[])

        return (
            <div className="cart-card" key={`wh-${props.uniquekey}`}>
                <div className="cart-card-container">
                    <div className="cart-item-header">
                        <div className="cart-warehouse-name">
                            {props.warehousename}
                        </div>
                        <div className="cart-shipping-method">
                            {props.shippingmethod}
                        </div>
                    </div>
                    <hr />
                    {
                        props.items.map((value, index)=>{
                            let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                            if(value.ImageName){
                                imgurl = `${CMS_URL}/images/upload/product/${value.Code}/${value.ImageName}`;
                            }
                            return (
                                <div className="cart-item-detail" key={`${value.WarehouseDetail.WarehouseID}-${index}`}>
                                    {/* <div className="cart-item-checkbox">
                                        <label>
                                            <input type="checkbox" />
                                            <span></span>
                                        </label>
                                    </div> */}
                                    <div className="cart-item-image">
                                        <img src={imgurl}/>
                                    </div>
                                    <div className="cart-item-summary">
                                        <div className="cart-item-name">
                                            <span>{value.ItemName}</span>
                                        </div>
                                        <div className="cart-item-price">
                                            Rp {numberWithCommas(value.ItemPrice)}
                                        </div>
                                        <div className="cart-item-name">
                                            {`${value.ItemQty} ${value.ItemUoM} (${(value.ItemQty * value.ItemWeight).toFixed(2)} Kg)`}
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div>
                <ul className="collapsible" style={{marginBottom:0}}>
                    <li>
                        <div className="collapsible-header"><i className="material-icons">location_on</i>{(props.shippingmethod == "PICKUP") ? "Pick Up" : "Shipping"} Address</div>
                        <div className="collapsible-body"><span>{
                            (props.shippingmethod == "PICKUP") ?
                            `${props.items[0].WarehouseDetail.WarehouseAddress},${props.items[0].WarehouseDetail.WarehouseSubDistrict},${props.items[0].WarehouseDetail.WarehouseCity},${props.items[0].WarehouseDetail.WarehouseProvince},${props.items[0].WarehouseDetail.WarehouseNation}` :
                            `${props.items[0].ShippingDetail.ShippingDetailAddress},${props.items[0].ShippingDetail.ShippingDetailCity},${props.items[0].ShippingDetail.ShippingDetailProvince},${props.items[0].ShippingDetail.ShippingDetailNation}`
                        }</span></div>
                    </li>
                </ul>
                </div>
                {
                    (props.shippingmethod != "PICKUP")?
                    (
                        (props.items[0].ExpeditionDetail.ExpeditionCode == "") ?
                        (
                            <div className="cart-expedition-container" onClick={()=>ClickExpedition(props.uniquekey, props.items[0].WarehouseDetail.WarehouseCityID, props.items[0].ShippingDetail.ShippingDetailCityOngkirID)}>
                                <div className="cart-expedition-name">
                                    <ExpeditionName/>
                                </div>
                                <div className="cart-expedition-icon">
                                <i className="material-icons">chevron_right</i>
                                </div>
                            </div>
                        ):
                        (
                            <div className="cart-expedition-container" onClick={()=>ClickExpedition(props.uniquekey, props.items[0].WarehouseDetail.WarehouseCityID, props.items[0].ShippingDetail.ShippingDetailCityOngkirID)}>
                                <div className="cart-expedition-name">
                                    {props.items[0].ExpeditionDetail.ExpeditionName}
                                </div>
                                <div className="cart-expedition-price">
                                    Rp. {numberWithCommas(props.items[0].ExpeditionDetail.ExpeditionFee)}
                                </div>
                            </div>
                        )

                    ):
                    ("")
                }
            </div>
        );
    }

    function ExpeditionClick(index, WHCityID, ShippingCityID, ClickItems){
        setSelectedIndex(index)
        setSelectedWHCityID(WHCityID)
        setSelectedShippingCityID(ShippingCityID)
        let weight = 0;
        ClickItems.map((value, key)=>{
            weight+= value.ItemWeight * value.ItemQty;
        })
        setTotalWeight(weight);
        setIsOpen(true);
    }

    function changeIsOpen(value){
        setIsOpen(value);
    }

    function changeIsOpenReward(value){
        setIsOpenReward(value);
    }

    function changeIsOpenBank(value){
        setIsOpenBank(value);
    }
    function changeIsOpenFAO(value){
        setIsOpenFAO(value);
    }

    function setExpedition(index, code, name, desc, price){
        let titems = [...cart];
        titems[index].ExpeditionDetail= {
            ExpeditionCode: code,
            ExpeditionName: name,
            ExpeditionDescription: desc,
            ExpeditionFee: price
        }
        // console.log(titems[index])
        setCart(titems);
        recalculate(titems)
    }

    function setBank(code, name){
        setPaymentMethod({
            Code : code,
            Name: name
        })
    }

    function addToCart(item){
        let copy = [...cart];
        let ada = false;
        let idx = -1;
        copy.forEach((element,index) => {
            if(element.ItemUnitID == item.ItemUnitID && element.ShippingMethod == item.ShippingMethod && element.WarehouseDetail.WarehouseID == item.WarehouseDetail.WarehouseID){
                idx = index;
                ada = true;
            }    
        })
        if(!ada){
            copy.push(item);
        }else{
            copy[idx] = item;
        }
        setCart(copy)
        recalculate(copy);
    }

    function changeIsOpenWarehouse(val){
        setIsOpenWarehouse(val)
    }

    function changeIsOpenQty(val){
        setIsOpenQty(val)
    }

    function getMinumimOrder(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            // body: urlencoded,
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/checkout/minimumorder`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    async function initMinimumOrder(){
        let amt = await getMinumimOrder();
        if(amt && amt.status == 200){
            // amt= amt.data;
            amt= 0;
            setMinimumOrder(amt);
        }
    }

    // function getStock(itemunitid){
    //     var myHeaders = new Headers();
    //     myHeaders.append("x-access-token", token);

    //     var requestOptions = {
    //         method: 'GET',
    //         // body: urlencoded,
    //         redirect: 'follow'
    //     };

    //     return fetch(`${API_URL}api/item/stock/${itemunitid}`, requestOptions)
    //     .then(response => response.json())
    //     .catch(error => console.log('error', {}));
    // }

    function getCityDetail(cityid){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/city/detail/${cityid}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    async function initAddress(cityid){
        let response = await getCityDetail(cityid);
        if(response && response.status == 200){
            response = response.data;
            let tAddress = {
                ID: 0,
                Alias: "Address",
                Name: formData["FirstName"] + " " + formData["LastName"],
                Phone: formData["WhatsappNumber"],
                Address: formData["Address"],
                District: "",
                City: formData["City"].label,
                Province: response.Province,
                ZipCode: formData["PostalCode"],
                Nation: response.Country,
                CityID: formData["City"].value,
                CityOngkirID: response.RajaOngkirID,
                ProvinceID: response.ProvinceID,
                CountryID: response.CountryID
            }
            let tCart = [...cart];
            tCart.forEach(element=>{
                if(element.ShippingMethod != "PICKUP"){
                    // element.ShippingDetail = {
                    //     ShippingDetailID: 0,
                    //     // ShippingDetailName: tAddress.Name,
                    //     // ShippingDetailPhone: tAddress.Phone,
                    //     // ShippingDetailAddress: tAddress.Address,
                    //     // ShippingDetailZipCode: tAddress.ZipCode,
                    //     // ShippingDetailCityID: tAddress.CityID,
                    //     ShippingDetailCityOngkirID: tAddress.CityOngkirID,
                    //     // ShippingDetailCity: tAddress.City,
                    //     ShippingDetailProvinceID: tAddress.ProvinceID,
                    //     ShippingDetailProvince: tAddress.Province,
                    //     ShippingDetailNationID: tAddress.CountryID,
                    //     ShippingDetailNation: tAddress.Nation,
                    // }
                    element.ShippingDetail.ShippingDetailCityOngkirID =  tAddress.CityOngkirID;
                    element.ShippingDetail.ShippingDetailProvinceID =  tAddress.ProvinceID;
                    element.ShippingDetail.ShippingDetailProvince =  tAddress.Province;
                    element.ShippingDetail.ShippingDetailNationID =  tAddress.CountryID;
                    element.ShippingDetail.ShippingDetailNation =  tAddress.Nation;
                }
            })
            setCart(tCart);
            setAddress(tAddress)
            setIsOpenBackdrop(false);
        }
    }

    const totalSteps = () => {
        return steps.length;
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const handleNext = async () => {
        // let newActiveStep =
        //     isLastStep() && !allStepsCompleted()
        //     ? // It's the last step, but not all steps have been completed,
        //         // find the first step that has been completed
        //         steps.findIndex((step, i) => !(i in completed))
        //     : activeStep + 1;
        let newActiveStep = activeStep + 1;
        if(newActiveStep == 0){
            initMinimumOrder();
            initItems();
        }
        else if(newActiveStep == 1){
            setIsOpenBackdrop(true);
            initForm();
        }else if(newActiveStep == 2){
            if (newActiveStep == 2 && sumTotal >= minimumOrder){
                let valid = await FormValidation();
                if(valid){
                    setIsOpenBackdrop(true);
                    initAddress();
                }else{
                    newActiveStep = 1;
                }
            }else{
                newActiveStep = 1;
                toast.error(`You haven't reach the minimum order`);
            }
        }else if(newActiveStep == 3){
            newActiveStep = 2;
            SubmitHandler();
        }
        setActiveStep(newActiveStep);
    };

    const handleBack = () => {

        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        if( (activeStep - 1 )=== 0){
            setIsOpenBackdrop(true);
            initForm();
        }
        if( (activeStep - 1 )=== 1){
            initMinimumOrder();
            initAddress();
            initItems();
        }else if(activeStep == 2){
            
        }
    };

    const handleStep = (step) => () => {
        setActiveStep(step);
        if(step == 0){
            setIsOpenBackdrop(true);
            initForm();
        }
        else if(step == 1){
            initMinimumOrder();
            initAddress();
            initItems();
        }else if(step == 2){
            
        }
    };

    const handleComplete = () => {
        const newCompleted = completed;
        newCompleted[activeStep] = true;
        setCompleted(newCompleted);
        handleNext();
    };

    const handleReset = () => {
        setActiveStep(0);
        setCompleted({});
    };

    const initForm = async ()=>{
        await initSponsor();
        await initCity();
        await initBank();
        var elems = document.querySelectorAll('select');
        var instances = M.FormSelect.init(elems, {});
        setIsOpenBackdrop(false);
    }   
    
    async function RegisterUser(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("firstname", document.getElementById("FirstName").value);
        urlencoded.append("lastname", document.getElementById("LastName").value);
        urlencoded.append("username", document.getElementById("Username").value);
        urlencoded.append("email", document.getElementById("Email").value);
        urlencoded.append("phone", document.getElementById("Phone").value);
        urlencoded.append("password", document.getElementById("Password").value);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/auth/register`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    async function CheckUsername(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("username", username);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/register/checkusername`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    async function CheckEmail(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("email", email);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/register/checkemail`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }
    async function CheckPhone(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("phone", phone);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/register/checkphone`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    async function FormValidation(){
        let valid = true;

        let fields = ["FirstName", "LastName", "Email", "WhatsappNumber","Address","PostalCode","ReferalName","ReferalCode"];
        // let fields = ["FirstName", "LastName", "IDNumber", "Email", "WhatsappNumber","MobilePhone","Address","PostalCode","AccountNumber","AccountName","ReferalCode","ReferalName"];
        
        fields.map((value)=>{
            let field = document.getElementById(value);
            console.log(value)
            if(!field || field.value == ""){
                document.getElementById(value+"Validation").setAttribute("data-error", "This field is required");
                field.classList.remove("valid");
                field.classList.add("invalid");
            }else{
                field.classList.remove("invalid");
                field.classList.add("valid");
            }
        })

        // if(document.getElementById("Email").value != ""){
        //     let response = await CheckEmail();
        //     response = JSON.parse(response)
        //     if(response.status == 200){
        //         document.getElementById("EmailValidation").setAttribute("data-error", response.message);
        //         document.getElementById("Email").classList.remove("valid");
        //         document.getElementById("Email").classList.remove("invalid");
        //         document.getElementById("Email").classList.add(response.class);
        //     }else{
    
        //     }
        // }

        // if(pswd != cpswd){
        //     document.getElementById("ConfirmPasswordValidation").setAttribute("data-error", "Password doesn't match");
        //     document.getElementById("ConfirmPassword").classList.remove("valid");
        //     document.getElementById("ConfirmPassword").classList.remove("invalid");
        //     document.getElementById("ConfirmPassword").classList.add("invalid");
        // }else{
            
        // }

        let countvalid = document.getElementsByClassName("invalid").length;
        valid = countvalid === 0;

        return valid;
    }

    function requestCheckout(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("items", JSON.stringify(cart));
        urlencoded.append("memberdata", JSON.stringify(formData));
        urlencoded.append("paymentmethod", JSON.stringify(paymentMethod));
        urlencoded.append("total", sumTotal);
        urlencoded.append("totalitem", sumOrder);
        urlencoded.append("shippingfee", sumShipping);


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/shopnow/checkout`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    function validationExpedition(){
        let valid = true;
        let prevwh = -1;
        cart.map((value, index)=>{
            if(prevwh != value.WarehouseDetail.WarehouseID){
                prevwh = value.WarehouseDetail.WarehouseID;
                if(value.ShippingMethod == "SHIP BY" && value.ExpeditionDetail.ExpeditionCode == "")
                    valid = false;
            }
        })
        return valid;
    }

    function validationPayment(){
        let valid = true;
        if(paymentMethod.Code == ""){
            valid = false;
        } 
        return valid;
    }

    async function SubmitHandler(){
        
        setIsOpenBackdrop(true);
        let valid = await FormValidation();
        if(!valid){
            toast.error('All fields are required!');
            setIsOpenBackdrop(false);
        }
        else if(cart.length == 0){
            toast.error('No item Selected');
            setIsOpenBackdrop(false);
        }
        else if(!validationExpedition()){
            toast.error('Select Expedition');
            setIsOpenBackdrop(false);
        }
        else if(!validationPayment()){
            toast.error('Select Payment Method');
            setIsOpenBackdrop(false);
        }
        else{
            await setLog(`${props.location.pathname + props.location.search}`, 'checkout');
            let response = await requestCheckout();
            response = JSON.parse(response);
            if(response.status == 200){
                window.history.replaceState(null, null, `/paymentinfo/${response.idpayment}`);
                toast.success("sukses")
                window.location.reload();
            }else{
                setIsOpenBackdrop(false);
                toast.error(response.message)
                // console.log(response.message)
            }
            // toast.success('success');
            // setIsOpenBackdrop(false);
        }
    }

    function fetchCity(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/city`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function initCity(){
        let response = await fetchCity();
        if(response.status == 200){
            // setCities(response.data);
            // let select = document.getElementById("City");
            // select.innerHTML = "";
            // (response.data).forEach(element => {
            //     let option = document.createElement("option");
            //     option.value = element.ID
            //     option.text = element.Name
            //     select.append(option);
            // });
            let temp = [];
            (response.data).forEach(element => {
                temp.push({value: element.ID, label: element.Name});
            })
            setCities(temp);
        }
    }

    function fetchSponsor(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        if(props.match.params.sponsorid){
            return fetch(`${API_URL}api/sponsor/${props.match.params.sponsorid}`, requestOptions)
            .then(response => response.json())
            .catch(error => console.log('error', error))
        }

        return fetch(`${API_URL}api/sponsor`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function initSponsor(){
        let response = await fetchSponsor();
        if(response.status == 200){
            let temp = [];
            (response.data).forEach(element => {
                updateSponsor({value: element.ID, label: `${element.Code} -  ${element.Name}`, name: element.Name, code: element.Code});
                temp.push({value: element.ID, label:`${element.Code} -  ${element.Name}`, name: element.Name, code: element.Code});
            })
            setSponsors(temp);
        }
    }

    function fetchBank(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/bank`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function initBank(){
        let response = await fetchBank();
        if(response.status == 200){
            // setCities(response.data);
            // let select = document.getElementById("Bank");
            // select.innerHTML = "";
            // (response.data).forEach(element => {
            //     let option = document.createElement("option");
            //     option.value = element.ID
            //     option.text = element.Abbreviation
            //     select.append(option);
            // });
            let temp = [];
            (response.data).forEach(element => {
                temp.push({value: element.ID, label: element.Abbreviation})
            })
            setBanks(temp);
        }
    }

    function updateFirstName(val){
        let copy = {...formData};
        copy["FirstName"] = val.target.value;
        copy["AccountName"] = (copy["FirstName"] + " " + copy["LastName"]).toUpperCase()
        let tCart = [...cart];
        tCart[0].ShippingDetail.ShippingDetailName = (copy["FirstName"] + " " + copy["LastName"]).toUpperCase();
        setCart(tCart);
        setFormData(copy);
    }
    
    function updateLastName(val){
        let copy = {...formData};
        copy["LastName"] = val.target.value;
        copy["AccountName"] = (copy["FirstName"] + " " + copy["LastName"]).toUpperCase()
        let tCart = [...cart];
        tCart[0].ShippingDetail.ShippingDetailName = (copy["FirstName"] + " " + copy["LastName"]).toUpperCase();
        setCart(tCart);
        setFormData(copy);
    }
    
    function updateGender(val){
        let copy = {...formData};
        copy["Gender"] = val;
        setFormData(copy);
    }
    
    function updateIDNumber(val){
        let copy = {...formData};
        let result = val.target.value;
        result = result.replace(/[^0-9]/g, '');
        copy["IDNumber"] = result;
        setFormData(copy);
    }

    function updateBirthDate(val){
        let copy = {...formData};
        copy["BirthDate"] = val.target.value;
        setFormData(copy);
    }
    
    function updateEmail(val){
        let copy = {...formData};
        copy["Email"] = val.target.value;
        setFormData(copy);
    }
    
    function updateWhatsappNumber(val){
        let copy = {...formData};
        let result = val.target.value;
        result = result.replace(/[^0-9]/g, '');
        copy["WhatsappNumber"] = result;
        let tCart = [...cart];
        tCart[0].ShippingDetail.ShippingDetailPhone = result;
        setCart(tCart);
        setFormData(copy);
    }
    
    function updateMobileNumber(val){
        let copy = {...formData};
        let result = val.target.value;
        result = result.replace(/[^0-9]/g, '');
        copy["MobileNumber"] = result;
        setFormData(copy);
    }
    
    function updateAddress(val){
        let copy = {...formData};
        copy["Address"] = val.target.value;
        let tCart = [...cart];
        tCart[0].ShippingDetail.ShippingDetailAddress = val.target.value;
        setCart(tCart);
        setFormData(copy);
    }
    
    function updateCity(val){
        let copy = {...formData};
        copy["City"] = val;
        let tCart = [...cart];
        tCart[0].ShippingDetail.ShippingDetailCity = val.label;
        tCart[0].ShippingDetail.ShippingDetailCityID = val.value;
        setCart(tCart);
        initAddress(val.value);
        setFormData(copy);
    }
    
    function updatePostalCode(val){
        let copy = {...formData};
        let result = val.target.value;
        result = result.replace(/[^0-9]/g, '');
        copy["PostalCode"] = result;
        let tCart = [...cart];
        tCart[0].ShippingDetail.ShippingDetailZipCode = result;
        setCart(tCart);
        setFormData(copy);
    }

    function updateBank(val){
        let copy = {...formData};
        copy["Bank"] = val;
        setFormData(copy);
    }

    function updateSponsor(val){
        let copy = {...formData};
        copy["Referal"] = val;
        copy["ReferalID"] = val.value
        copy["ReferalCode"] = val.code;
        copy["ReferalName"] = val.name;
        setFormData(copy);
    }

    function updateAccountNumber(val){
        let copy = {...formData};
        let result = val.target.value;
        result = result.replace(/[^0-9]/g, '');
        copy["AccountNumber"] = result;
        setFormData(copy);
    }

    function updateAccountName(val){
        let copy = {...formData};
        copy["AccountName"] = (val.target.value).toUpperCase();
        setFormData(copy);
    }

    const getAllItems = ()=>{
        return items;
    }

    function openItemQtyHandler(item){
        setItemID(item.ID)
        setItemUnitID(item.ItemUnitID)
        setItemName(item.Name)
        setItemCode(item.Code)
        setItemPrice(item.CatalogPrice)
        setItemWeight(item.Weight)
        setItemSize(item.Size)
        setItemColor(item.Color)
        setItemImage(item.ImageName)
        setSelectedItemUnitID(item.ItemUnitID)
        setSelectedItem(item);

        
        addToCart({
            ID: new Date()/1,
            PromoID: 0,
            PromoCode: "",
            PromoName: "",
            ItemID: item.ID,
            ItemUnitID: item.ItemUnitID,
            ItemName: item.Name,
            ItemQty: qty,
            ItemUoM: "PCS",
            ItemPrice: item.CatalogPrice,
            ItemWeight: item.Weight,
            ItemColor: item.Color,
            ItemSize: item.Size,
            ImageName: item.ImageName,
            Code: item.Code,
            IsChecked : 1,
            Stock: warehouse.Stock,
            WarehouseDetail:{
                CompanyID: warehouse.CompanyID,
                BranchID: warehouse.BranchID,
                WarehouseID: warehouse.WarehouseID,
                WarehouseName: warehouse.Name,
                WarehousePhone: "",
                WarehouseAddress: warehouse.Address,
                WarehouseSubDistrict: "",
                WarehouseCity: warehouse.CityName,
                WarehouseCityID: warehouse.CityID,
                WarehouseProvince: warehouse.ProvinceName,
                WarehouseNation: "Indonesia",
            },
            ShippingMethod: shippingMethod,
            ExpeditionDetail: {
                ExpeditionCode: "",
                ExpeditionName: "",
                ExpeditionFee: 0,
            },
            ShippingDetail: {
                ShippingDetailID: 0,
                ShippingDetailName: address.Name,
                ShippingDetailPhone: address.Phone,
                ShippingDetailAddress: address.Address,
                ShippingDetailZipCode: address.ZipCode,
                ShippingDetailCityID: address.CityID,
                ShippingDetailCityOngkirID: address.CityOngkirID,
                ShippingDetailCity: address.City,
                ShippingDetailProvinceID: address.ProvinceID,
                ShippingDetailProvince: address.Province,
                ShippingDetailNationID: address.CountryID,
                ShippingDetailNation: address.Nation,
            }
        })
    }

    function searchItemPress(e){
        if(e.charCode == 13){
            searchItem();
        }
    }

    function searchItem(){
        setIsLoading(false);
        setHasMore(true);
        setItemPage(1);
        setItems([]);
        setTimeout(()=>{
            initItems();
        },100);
    }

    async function loadMore(){
        if(!isLoading && hasMore){
            // await this.setState({
            //     itemPage: this.state.itemPage+1,
            //     // hasMore: false,
            //     isLoading: true
            // })
            setIsLoading(true);
            let search = props.location.search;
            let category = new URLSearchParams(search).get('c');
            category = (category == null) ? "" : category;
            let queryparam = `&q=${searchQuery}`;
            let categoryparam = `&c=${category}`;
            let param = queryparam;
            if(searchQuery == "" && category == ""){

            }else if(searchQuery == "" && category != ""){
                param = categoryparam;
            }else if(searchQuery != "" && category != ""){
                param = queryparam;
            }
            // setHasMore(false)
            var urlencoded = new URLSearchParams();
    
            var requestOptions = {
                method: 'GET',
                // body: urlencoded,
                redirect: 'follow'
            };
    
            return fetch(`${API_URL}api/search?p=${itemPage}&rp=10${param}`, requestOptions)
            .then(response => response.json() )
            .catch(error => {
                // this.setState({isLoading: false})
                setIsLoading(false);
            });
        }
    }

    async function initItems(){
        let res = await loadMore();
        if(res && res.status == 200){
            if(res.data.length == 0){
                setHasMore(false);
            }

            let titems = [...items];
            let data= res.data;
            data.map((value, index)=>{
                let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                if(value.ImageName){
                    imgurl = `${CMS_URL}/images/upload/product/${value.Code}/${value.ImageName}`;
                }
                titems.push(
                    <div className="home-item" key={value.ItemUnitID}>
                        <div onClick={() => openItemQtyHandler(value)}>
                            <div style={{position:"relative", width:"100%", paddingTop:"100%"}}>
                                <img className="home-item-image" src={imgurl} />
                            </div>
                            <div style={{flex:"1 0 auto", display:"flex", flexDirection:"column", padding:".625rem",overflow:"hidden"}}>
                                <div style={{flex:"1 0 auto", display:"flex", flexDirection:"column", padding:".625rem",overflow:"hidden"}}>
                                    <div style={{flexGrow: "1", minHeight: "1.75rem"}}>
                                        <div className="home-item-title">{value.Name}</div>
                                    </div>
                                </div>
                                <div className="home-item-detail">
                                    <div className="home-item-price">
                                        <span style={{fontSize:".75rem",color:`${THEME_COLOR}`}}>Rp</span>
                                        <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontSize:"1rem",color:THEME_COLOR}}>{numberWithCommas(value.CatalogPrice)}</span>
                                    </div>
                                    <div className="home-item-sold">{value.Sales} Sold</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
            // this.setState({
            //     items: items,
            //     isLoading: false
            // })
            setItems(titems);
            setItemPage(itemPage+1);
            setIsLoading(false);
            // setHasMore(false);
        }
        setIsOpenBackdrop(false);
    }

    function recalculate(cart){
        let sum = 0;
        let grandtotal = 0;
        let shippingfee = 0;
        cart.map((value, index)=>{
            if(value.IsChecked)
                sum += (value.ItemQty * value.ItemPrice);
                grandtotal += (value.ItemQty * value.ItemPrice);
                if(value.ShippingMethod == "SHIP BY"){
                    grandtotal += parseInt(value.ExpeditionDetail.ExpeditionFee)
                    shippingfee += parseInt(value.ExpeditionDetail.ExpeditionFee)
                }
        })
        setSumTotal(grandtotal);
        setSumOrder(sum);
        setSumShipping(shippingfee)
    }

    function getItemDetail(){
        let search = props.location.search;
        let itemunitid = new URLSearchParams(search).get('i');
        itemunitid = (itemunitid == null) ? "" : itemunitid;

        var requestOptions = {
            method: 'GET',
            // body: urlencoded,
            redirect: 'follow'
        };

        // return fetch(`${API_URL}api/item/${lastViewedItem}`, requestOptions)
        return fetch(`${API_URL}api/item/${itemunitid}`, requestOptions)
        .then(response => response.json() )
        .catch(error => {
            // this.setState({isLoading: false})
            setIsLoading(false);
        });
    }

    async function initItemDetail(){
        let response = await getItemDetail();
        if(response && response.status == 200){
            openItemQtyHandler(response.data);
        }
    }

    

    function getAvailableStock(){
        
        var urlencoded = new URLSearchParams();
        urlencoded.append("type", "Ecommerce_Available_Stock");
        urlencoded.append("row", 1);

        var requestOptions = {
            method: 'POST',
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/configuration`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    async function initConfig(){
        let response = await getAvailableStock();
        if(response && response.status == 200){
            setAvailStockConfig(response.data)
        }
    }

    function getStock(){
        let search = props.location.search;
        let itemunitid = new URLSearchParams(search).get('i');
        itemunitid = (itemunitid == null) ? "" : itemunitid;

        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("x-wh", wh);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        // return fetch(`${API_URL}api/item/stock/${props.itemunitid}`, requestOptions)
        return fetch(`${API_URL}api/item/whstock/${itemunitid}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    async function initWarehouse(){
        let data = await getStock();
        if(data){
            if(data.status == 200){
                data = data.data;
                setWarehouses(data)
                if(data && data.length >0){
                    setWarehouse({
                        ID: data[0].WarehouseID,
                        CompanyID: data[0].CompanyID,
                        BranchID: data[0].BranchID,
                        WarehouseID: data[0].WarehouseID,
                        Name : data[0].WarehouseName,  
                        Stock : data[0].QtyEnd,  
                        CityID: data[0].CityOngkirID,
                        CityName : data[0].CityName,
                        ProvinceID: data[0].ProvinceID,
                        ProvinceName: data[0].ProvinceName,
                        Address : data[0].WarehouseAddress,  
                    })
                    let WarehouseDetail = {
                        CompanyID: data[0].CompanyID,
                        BranchID: data[0].BranchID,
                        WarehouseID: data[0].WarehouseID,
                        WarehouseName: data[0].WarehouseName,
                        WarehousePhone: "",
                        WarehouseAddress: data[0].WarehouseAddress,
                        WarehouseSubDistrict: "",
                        WarehouseCity: data[0].CityName,
                        WarehouseCityID: data[0].CityOngkirID,
                        WarehouseProvince: data[0].ProvinceName,
                        WarehouseNation: "Indonesia",
                    };
                    setWarehouseDetail(WarehouseDetail);
                }else{
                    setWarehouse({
                        ID: 0,
                        Name: "",
                        Stock: 0,
                    })
                    let WarehouseDetail = {
                        CompanyID: "",
                        BranchID: "",
                        WarehouseID: "",
                        WarehouseName: "",
                        WarehousePhone: "",
                        WarehouseAddress: "",
                        WarehouseSubDistrict: "",
                        WarehouseCity: "",
                        WarehouseCityID: "",
                        WarehouseProvince: "",
                        WarehouseNation: "",
                    };
                    setWarehouseDetail(WarehouseDetail);
                }
            }
            else{
                toast.error(data.message)
            }
        }else{
            toast.error("couldn't connect to server")
        }
    }

    async function decrementQty(){
        let tqty = parseInt(qty) - 1;
        if(tqty < 1){
            tqty = 1;
        }
        if(tqty > warehouse.Stock){
            tqty = warehouse.Stock;
        }
        let tCart = [...cart];
        tCart[0].WarehouseDetail = warehouseDetail;
        tCart[0].ItemQty = tqty;
        setCart(tCart);
        setQty(tqty);
        recalculate(tCart);
    }

    function incrementQty(){
        let tqty = parseInt(qty) + 1;
        if(tqty > warehouse.Stock){
            tqty = warehouse.Stock;
        }
        let tCart = [...cart];
        tCart[0].WarehouseDetail = warehouseDetail;
        tCart[0].ItemQty = tqty;
        setCart(tCart);
        setQty(tqty);
        recalculate(tCart);
    }

    async function qtyChange(e){
        let tqty = (!e.target.value || e.target.value=="" || e.target.value == isNaN)? 1: parseInt(e.target.value);
        if(tqty < 2){
            tqty = 1;
        }
        if(tqty > warehouse.Stock){
            tqty = warehouse.Stock;
        }
        let tCart = [...cart];
        tCart[0].WarehouseDetail = warehouseDetail;
        tCart[0].ItemQty = tqty;
        setCart(tCart);
        setQty(tqty);
        recalculate(tCart);
    }

    function qtyKeyPress(event){
        if(! (event.charCode >= 46 && event.charCode <= 57)){
            event.preventDefault();
        }
    }

    function setLog(url, type){
        var urlencoded = new URLSearchParams();
        urlencoded.append("address", url);
        urlencoded.append("type", type);


        var requestOptions = {
            method: 'POST',
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/log`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    function clickLink(url, type){
        setLog(url, type);
        window.open(url, '_blank').focus();
    }

    useEffect(async ()=>{
        await setLog(`${props.location.pathname + props.location.search}`, 'buy');
        let search = props.location.search;
        let itemunitid = new URLSearchParams(search).get('i');
        itemunitid = (itemunitid == null) ? "" : itemunitid;
        if(itemunitid == ""){
            window.history.replaceState(null, null, `/`);
            window.location.reload();
        }
        setIsOpenBackdrop(true);
        initConfig();
        initItemDetail();
        initWarehouse();
        if(lastViewedItem != ""){
            setIsOpenBackdrop(false);
            setLastViewedItem("");
        }
        initForm();
        let el = document.getElementById("tabs");
        let options = {};
        var instance = M.Tabs.init(el, options);
    },[])

    let renderFragment = <React.Fragment></React.Fragment>;
    if(activeStep == 0){
        renderFragment = (
            <>
                <nav>
                    <div className="nav-wrapper" style={{backgroundColor:"white"}}>
                        <div className="input-field">
                        <input id="search" type="search" value={searchQuery} onChange={(e)=>setSearchQuery(e.target.value)} onKeyPress={searchItemPress}/>
                        <label className="label-icon" for="search"><i className="material-icons" style={{color:"black"}}>search</i></label>
                        <i className="material-icons" style={{color:"black"}} onClick={()=>{setSearchQuery(""); searchItem();}}>close</i>
                        </div>
                    </div>
                </nav>
                <div className="row">
                    <h5>Shop</h5>
                </div>
                <InfiniteScroll
                    pageStart={itemPage}
                    loadMore={initItems}
                    hasMore={hasMore}
                    loader={<div style={{width: "100%"}}>loading...</div>}
                    children={``}
                >
                    <div className="" style={{display:"flex",flexWrap:"wrap",paddingBottom:"80px"}}>
                        {/* {getAllItems()} */}
                        {items}
                    </div>
                </InfiniteScroll>
            </>
        );

    }
    else if(activeStep == 1){
        renderFragment = (
            <>
            </>
        );
    }
    else if(activeStep == 2){
        renderFragment = (
            <>
                <div style={{width:"100%", padding: "10px 0", marginBottom:"70px"}}>

                    {
                        cart.map((value, index)=>{
                            if(prevwh != value.WarehouseDetail.WarehouseID || prevshipmethod != value.ShippingMethod || prevshipdetail != value.ShippingDetail.ShippingDetailID){
                                prevwh = value.WarehouseDetail.WarehouseID;
                                prevshipmethod = value.ShippingMethod;
                                prevshipdetail = value.ShippingDetail.ShippingDetailID;
                                let filteritem = cart.filter((value,index)=> value.WarehouseDetail.WarehouseID == prevwh && value.ShippingMethod == prevshipmethod && value.ShippingDetail.ShippingDetailID == prevshipdetail );
                                return (
                                    <Cardcontainer
                                        items={filteritem}
                                        key={index}
                                        uniquekey={index}
                                        warehousename={value.WarehouseDetail.WarehouseName}
                                        shippingmethod= {value.ShippingMethod}
                                        onClick={()=> ExpeditionClick(index, value.WarehouseDetail.WarehouseCityID, value.ShippingDetail.ShippingDetailCityOngkirID,filteritem)}
                                    />
                                )
                            }
                        })
                    }

                </div>
                    {
                        (activeStep == 2) ? (
                            <div className="cart-card">
                                <div className="cart-footer">
                                    <div className="cart-payment-label"  style={{flexGrow:1}}>
                                        Payment Method
                                    </div>
                                    <div className="cart-payment-name" onClick={()=> { setIsOpenBank(true) }}>
                                        {
                                            (!paymentMethod || paymentMethod.Code == "")?
                                            (
                                                "Choose VA >"
                                            ):
                                            (
                                                paymentMethod.Name
                                            )
                                        }
                                    </div>
                                </div>
                                <div style={{height:"50px"}}>
                                </div>
                            </div>
                        ) : (<></>)
                    }
                <SlidingPane
                    className="cart-expedition-panel"
                    closeIcon={<span><i className="material-icons">close</i></span>}
                    isOpen={isOpen}
                    title="Choose Expedition"
                    from="bottom"
                    width= "100%"
                    onRequestClose={() => setIsOpen(false)}
                >
                    <Expedition
                        index = {selectedIndex}
                        changeIsOpen = {changeIsOpen}
                        setExpedition = {setExpedition}
                        whcityid = {selectedWHCityID}
                        shippingcityid = {selectedShippingCityID}
                        totalweight = {totalWeight}

                    />
                </SlidingPane>
                <SlidingPane
                    className="cart-expedition-panel"
                    closeIcon={<span><i className="material-icons">close</i></span>}
                    isOpen={isOpenBank}
                    title="Choose Bank"
                    from="bottom"
                    width= "100%"
                    onRequestClose={() => setIsOpenBank(false)}
                >
                    <Bank
                        changeIsOpenBank = {changeIsOpenBank}
                        setBank = {setBank}
                    />
                </SlidingPane>
            </>
        );
    }
    else{
        renderFragment = <React.Fragment></React.Fragment>;
    }
    
    return(
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <HeaderBack title="Shop" /> 
            <div className="row" style={{padding:"10px", backgroundColor:"white"}}>
                <Box sx={{ width: '100%' }}>
                    <div className="row">
                        <h5>Item Information</h5>
                        <div className="shipping-container">
                            <div className="shipping-item-container">
                                <div className="shipping-flex-container">
                                    <div className="shipping-item-image">
                                        <img src={`${CMS_URL}/images/upload/product/${itemCode}/${itemImage}`} />
                                    </div>
                                    <div className="shipping-item-detail">
                                        <p className="detail-item-name">{itemName}</p>
                                        <p className="detail-item-price">Rp {numberWithCommas((itemPrice === 0) ? itemPrice : itemPrice)}</p>
                                        <p style={{fontSize:"10pt"}}>Weight: {itemWeight} kg</p>
                                    </div>
                                </div>
                            </div>
                            <div className="shipping-flex-container" style={{alignItems:"center"}}>
                                <div className="shipping-flex-grow">Qty:</div>
                                <div className="detail-flex-item">
                                    <button className="detail-rounded-btn" onClick={decrementQty}>-</button>
                                </div>
                                <div className="detail-flex-item" style={{textAlign:"center"}}>
                                    <input type="text" value={qty} onChange={qtyChange} onKeyPress={qtyKeyPress}/>
                                </div>
                                <div className="detail-flex-item">
                                    <button  className="detail-rounded-btn" onClick={incrementQty}>+</button>
                                </div>
                            </div>
                            <div className="shipping-flex-container">
                                <div className="shipping-flex-grow">Total Weight:</div>
                                <div><strong>{(itemWeight * qty).toFixed(2)} Kg</strong></div>
                            </div>
                        </div>
                        <div className="shipping-container" style={{display:"none"}}>
                            <div className="detail-header">Shipping Method</div>
                            <div className="row">
                                <div className={`col s12`}>
                                    <ul className="tabs" id="tabs">
                                        <li className="tab col s6" onClick={ e=>{setShippingMethod("SHIP BY")} }><a href="#test2">Delivery</a></li>
                                        <li className="tab col s6" onClick={ e=>{setShippingMethod("PICKUP")} }><a href="#test1">Pick up</a></li>
                                    </ul>
                                </div>
                                <div id="test1" className="col s12">
                                    <div className="shipping-flex-container" style={{display:"none"}}>
                                        <div className="shipping-item-image" style={{display:"none"}}>
                                        </div>
                                        <div className="shipping-item-detail center">
                                            <p className="detail-item-name">PICKUP</p>
                                            <p style={{fontSize:"10pt"}}>Select the address where you like to pickup the package..</p>
                                        </div>
                                    </div>
                                </div>
                                <div id="test2" className="col s12">
                                    {
                                        (props.address)?(
                                            <div className="shipping-info-container" style={{padding:"10px"}}>
                                                <div className="shipping-information-header">{props.address.Alias}</div>
                                                <div className="shipping-information-header">{props.address.Name}</div>
                                                <div>{props.address.Phone}</div>
                                                <div>{props.address.Address},{props.address.City},{props.address.Province},{props.address.Nation}</div>
                                            </div>
                                        ):(
                                            <></>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <h5>Shipping Information</h5>
                    </div>
                    <div className="row">
                        <div className="input-field col s6">
                            <input placeholder="First Name" id="FirstName" type="text" className="input-upper validate" required value={formData["FirstName"]} onChange={updateFirstName}/>
                            <label className="active" htmlFor="FirstName" data-error="wrong">First Name</label>
                            <span className="helper-text" id="FirstNameValidation" data-error="this field is required" data-success=""></span>
                        </div>
                        <div className="input-field col s6">
                            <input placeholder="Last Name" id="LastName" type="text" className="input-upper validate" required value={formData["LastName"]} onChange={updateLastName} />
                            <label className="active" htmlFor="LastName">Last Name</label>
                            <span className="helper-text" id="LastNameValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="input-field col s6">
                            <input placeholder="Email" id="Email" type="email" className="validate" required value={formData["Email"]} onChange={updateEmail}/>
                            <label className="active" htmlFor="Email">Email</label>
                            <span className="helper-text" id="EmailValidation" data-error="this field is required" data-success=""></span>
                        </div>
                        <div className="input-field col s6">
                            <input placeholder="08XXXXXXXXXX" id="WhatsappNumber" type="text" className="validate" required value={formData["WhatsappNumber"]} onChange={updateWhatsappNumber}/>
                            <label className="active" htmlFor="WhatsappNumber" data-error="wrong">Whatsapp Number</label>
                            <span className="helper-text" id="WhatsappNumberValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="input-field col s12">
                            <textarea id="Address" className="materialize-textarea" required onChange={updateAddress} value={formData["Address"]}></textarea>
                            <label className="active" htmlFor="Address" data-error="wrong">Address</label>
                            <span className="helper-text" id="AddressValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="input-field col s6">
                            <Select
                                options={cities}
                                value={formData["City"]}
                                onChange={updateCity}
                                placeholder = {`City`}
                            ></Select>
                            {/* <select className="form-control" id="City">
                            </select>
                            <label className="" htmlFor="City">City</label>
                            <span className="helper-text" id="ProvinceValidation" data-error="this field is required" data-success=""></span> */}
                        </div>
                        <div className="input-field col s6">
                            <input placeholder="Postal Code" id="PostalCode" type="text" className="validate" required value={formData["PostalCode"]} onChange={updatePostalCode} />
                            <label className="active" htmlFor="PostalCode">Postal Code</label>
                            <span className="helper-text" id="PostalCodeValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>

                    
                    
                    <div className="row">
                        <h5>Referral Information</h5>
                    </div>

                    <div className="row">
                        <div className="input-field col s12">
                            {/* <label className="" htmlFor="Referal">Referal</label>
                            <span className="helper-text" id="ReferalValidation" data-error="this field is required" data-success=""></span> */}
                            <Select
                                options={sponsors}
                                value = {formData["Referal"]}
                                onChange = {updateSponsor}
                            ></Select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s6">
                            <input readOnly="true" placeholder="Referral Code" id="ReferalCode" type="text" className="validate" required value={formData["ReferalCode"]}/>
                            <label className="active" htmlFor="ReferalCode">Referral Code</label>
                            <span className="helper-text" id="ReferalCodeValidation" data-error="this field is required" data-success=""></span>
                        </div>
                        <div className="input-field col s6">
                            <input readOnly="true" placeholder="Referral Name" id="ReferalName" type="text" className="validate" required value={formData["ReferalName"]} />
                            <label className="active" htmlFor="ReferalName">Referral Name</label>
                            <span className="helper-text" id="ReferalNameValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>
                    <div className="row">
                        <h5>Warehouse Information</h5>
                    </div>
                    <div className="row">
                        <div style={{marginBottom:"20px"}}>
                            <div className="shipping-info-container" style={{padding:"10px"}}>
                                <div className="shipping-information-header">{warehouse.Name}</div>
                                {
                                    (availStockConfig.Value == 1) ?(
                                        <div className="shipping-information-header">Stock: {warehouse.Stock}</div>
                                    ):(<></>)
                                }
                                <div></div>
                                {(warehouse.CityName && warehouse.CityName != "") ? (
                                    <div>{warehouse.Address}, {warehouse.CityName}, {warehouse.ProvinceName}, Indonesia</div>) : <></>}
                                {/* <hr/>
                                <div className="right-align">
                                    <button className={`btn ${THEME_COLOR}`} onClick={()=> setIsOpenWarehouse(true)}>Change</button>
                                </div> */}

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <h5>Payment Information</h5>
                    </div>
                    <div className="row">
                        <div style={{width:"100%", padding: "10px 0", marginBottom:"20px"}}>
                            {
                                cart.map((value, index)=>{
                                    if(prevwh != value.WarehouseDetail.WarehouseID || prevshipmethod != value.ShippingMethod || prevshipdetail != value.ShippingDetail.ShippingDetailID){
                                        prevwh = value.WarehouseDetail.WarehouseID;
                                        prevshipmethod = value.ShippingMethod;
                                        prevshipdetail = value.ShippingDetail.ShippingDetailID;
                                        let filteritem = cart.filter((value,index)=> value.WarehouseDetail.WarehouseID == prevwh && value.ShippingMethod == prevshipmethod && value.ShippingDetail.ShippingDetailID == prevshipdetail );
                                        return (
                                            <Cardcontainer
                                                items={filteritem}
                                                key={index}
                                                uniquekey={index}
                                                warehousename={value.WarehouseDetail.WarehouseName}
                                                shippingmethod= {value.ShippingMethod}
                                                onClick={()=> ExpeditionClick(index, value.WarehouseDetail.WarehouseCityID, value.ShippingDetail.ShippingDetailCityOngkirID,filteritem)}
                                            />
                                        )
                                    }
                                })
                            }

                            </div>
                            
                            <div className="cart-card">
                                <div className="cart-footer">
                                    <div className="cart-payment-label"  style={{flexGrow:1}}>
                                        Order Subtotal
                                    </div>
                                    <div>Rp. {numberWithCommas(sumOrder)}</div>
                                </div>
                                <div className="cart-footer">
                                    <div className="cart-payment-label"  style={{flexGrow:1}}>
                                        Shipping Fee
                                    </div>
                                    <div>Rp. {numberWithCommas(sumShipping)}</div>
                                </div>
                                <div className="cart-footer">
                                    <div className="cart-payment-label"  style={{flexGrow:1}}>
                                        Payment Method
                                    </div>
                                    <div className="cart-payment-name" onClick={()=> { setIsOpenBank(true) }}>
                                        {
                                            (!paymentMethod || paymentMethod.Code == "")?
                                            (
                                                "Choose VA >"
                                            ):
                                            (
                                                paymentMethod.Name
                                            )
                                        }
                                    </div>
                                </div>
                                <div style={{height:"50px"}}>
                                </div>
                            </div>
                            <SlidingPane
                            className="cart-expedition-panel"
                            closeIcon={<span><i className="material-icons">close</i></span>}
                            isOpen={isOpen}
                            title="Choose Expedition"
                            from="bottom"
                            width= "100%"
                            onRequestClose={() => setIsOpen(false)}
                            >
                            <Expedition
                                index = {selectedIndex}
                                changeIsOpen = {changeIsOpen}
                                setExpedition = {setExpedition}
                                whcityid = {selectedWHCityID}
                                shippingcityid = {selectedShippingCityID}
                                totalweight = {totalWeight}

                            />
                            </SlidingPane>
                            <SlidingPane
                            className="cart-expedition-panel"
                            closeIcon={<span><i className="material-icons">close</i></span>}
                            isOpen={isOpenBank}
                            title="Choose Bank"
                            from="bottom"
                            width= "100%"
                            onRequestClose={() => setIsOpenBank(false)}
                            >
                            <Bank
                                changeIsOpenBank = {changeIsOpenBank}
                                setBank = {setBank}
                            />
                            </SlidingPane>
                    </div>
                </Box>
            </div>
            
            <div className="cart-bottom">
                
                <div className="cart-footer">
                    <div className="" style={{display:"none"}} onClick={()=> {setIsOpenCart(true)} }>
                        <i className="material-icons">local_grocery_store</i>
                    </div>
                    <div className="" style={{flex:"2"}}>
                        <div className="cart-footer-sub">SubTotal</div><div className="cart-footer-price">Rp {numberWithCommas(sumTotal)}</div>
                    </div>
                    <div style={{flex:1}}>
                        <button className={`btn ${THEME_COLOR}`} style={{minWidth:"160px"}} onClick={SubmitHandler}>
                            Check Out
                        </button>
                    </div>
                </div>
            </div>
            {/* <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenWarehouse}
                title="Choose Warehouse"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpenWarehouse(false)}
            >
                <Warehouse
                    warehouses = {warehouses}
                    changeIsOpenWarehouse = {changeIsOpenWarehouse}
                    setWarehouse = {setWarehouse}
                />
            </SlidingPane> */}

            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenQty}
                title="Select Qty"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpenQty(false)}
            >
                <ItemInfo
                    itemid = {itemID}
                    itemcode = {itemCode}
                    itemname = {itemName}
                    itemprice = {itemPrice}
                    itemweight = {itemWeight}
                    itemunitid = {selectedItemUnitID}
                    imagename = {itemImage}
                    changeIsOpenWarehouse = {changeIsOpenWarehouse}
                    changeIsOpenQty = {changeIsOpenQty}
                    // address = {address}
                    setCart = {addToCart}
                    item = {selectedItem}
                />
            </SlidingPane>
            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenFAO}
                title="Choose FAO"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpenFAO(false)}
            >
                <FAO
                    changeIsOpenFAO = {changeIsOpenFAO}
                    setfao = {setfao}
                    fao = {fao}
                    items = {cart}
                    setItems = {setCart}
                />
            </SlidingPane>
            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenCart}
                title="Cart"
                from="bottom"
                width= "100%"
                children={<div></div>}
                onRequestClose={() => {
                    setIsOpenCart(false);
                    recalculate(cart);
                }}
            >
                <MiniCart
                    setCart = {setCart}
                    items= {cart.sort(function(a, b){
                        return a.WarehouseID - b.WarehouseID;
                    })}
                />
            </SlidingPane>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isOpenBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </React.StrictMode>
    );
}

export default ShopNow;
